import { mapActions, mapState } from 'vuex'
import dateUtils from '../../../../common/utils/dateUtil'
import moment from 'moment'

export default {
  data () {
    return {
      activeName: 'first',
      pageSize: 3,
      pageNum: 1
    }
  },
  computed: {
    ...mapState('cancelCouponModule', ['cancelRecordList']),
    cancelRecordInfo () {
      return this.cancelRecordList
    }
  },
  methods: {
    ...mapActions('cancelCouponModule', ['getCancelRecord', 'updateCouponRecord', 'updateCouponFalseRecord']),
    dateFormat (time) {
      return time ? moment(time).format('YYYY/MM/DD') : ''
    },
    arrowDown (e) {
      this.updateCouponRecord(e)
    },
    arrowUp (e) {
      this.updateCouponFalseRecord(e)
    },
    writeOffRecordExpandMore () {
      this.pageSize = this.pageSize + 3
      this.getCancelRecord({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        pageOrder: 'desc',
        pageSort: 'verify_sales_time'
      })
    }
  },
  mounted () {
    this.getCancelRecord({
      pageNum: this.pageNum,
      pageSize: this.pageSize,
      pageOrder: 'desc',
      pageSort: 'verify_sales_time'
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/cancel-coupon/views/cancel-record.js